import * as _time2 from "@walletconnect/time";
var _time = "default" in _time2 ? _time2.default : _time2;
var exports = {};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEARTBEAT_EVENTS = exports.HEARTBEAT_INTERVAL = void 0;
const time_1 = _time;
exports.HEARTBEAT_INTERVAL = time_1.FIVE_SECONDS;
exports.HEARTBEAT_EVENTS = {
  pulse: "heartbeat_pulse"
};
//# sourceMappingURL=heartbeat.js.map
export default exports;